/** Aligné sur /api/acheter : il faut statut actif + current_period_end dans le futur. */
export function isSubscriptionRowActive(s) {
  if (!s || s.statut !== "active") return false;
  if (!s.current_period_end) return false;
  const t = new Date(s.current_period_end).getTime();
  return Number.isFinite(t) && t > Date.now();
}

/** Abonnement payant en cours (admin stats + liste utilisateurs). */
export function isSubscriptionRowPaidActive(row) {
  const st = String(row?.statut || "").trim().toLowerCase();
  if (!["active", "trialing"].includes(st)) return false;
  const end = row?.current_period_end;
  if (!end) return true;
  const t = Date.parse(String(end));
  return Number.isFinite(t) && t > Date.now();
}

export async function waitForActiveSubscription(api, opts = {}) {
  const attempts = opts.attempts ?? 14;
  const delayMs = opts.delayMs ?? 750;
  for (let i = 0; i < attempts; i += 1) {
    try {
      const r = await api.get("/subscriptions/me");
      const sub = r?.data?.subscription || null;
      if (isSubscriptionRowActive(sub)) return true;
    } catch {}
    await new Promise((r) => window.setTimeout(r, delayMs));
  }
  return false;
}

/** Idempotent côté serveur — même logique que /subscriptions/activate. */
export async function recoverSubscription(api, { plan, paymentIntentId }) {
  return api.post("/subscriptions/recover", {
    plan,
    payment_intent_id: String(paymentIntentId),
  });
}
